import * as React from 'react';
import {Breadcrumb, Dropdown, Grid, Responsive, Segment} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    AdditionalDataServiceComponentProps,
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps, withAdditionalDataServices,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers, withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../lib/RestClient';
import {SortSelectionButton} from "../../components/DataTable/SortModal";
import {DataList} from "../../components/DataTable/DataList";
import {ViewLoadingSpinner} from "../../components/ViewLoadingSpinner";
import {TranslationFunction} from "i18next";
import {getGroupType} from "./common";
import {decodeVstGrp} from "./vstGrpToken";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);


const COLUMNS: ColumnDefinition[] = [
  {fieldName: 'data.AnliefererNr', labelTranslationKey:'Offer.AnliefererNr', required: false},
  {fieldName: 'data.AnlName', labelTranslationKey:'Offer.AnlName', required: true},
  {fieldName: 'data.ArtikelNr',labelTranslationKey: 'Offer.ArtikelNr',required: true},
  {fieldName: 'data.ArtikelBez',labelTranslationKey: 'Offer.ArtikelBez',required: true  },
  {fieldName: 'data.Qualitaet',labelTranslationKey: 'Offer.Qualitaet'},
  {fieldName: 'data.SCodeWert01Text',labelTranslationKey: 'Offer.Laenge'},
  {fieldName: 'data.SCodeWert02Text',labelTranslationKey: 'Offer.Gewicht'},
  {fieldName: 'data.Einheiten',labelTranslationKey: 'Offer.Einheiten', cellAlign: 'right'},
  {fieldName: 'data.EinheitsMenge',labelTranslationKey: 'Offer.EinheitsMenge', cellAlign: 'right'},

  {fieldName: 'data.EinheitenGesamt', labelTranslationKey: 'Offer.Gesamt', cellAlign: 'right'}
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const DataPage = (props: {dateFrom?: Date; dateTo?: Date;} & RouteComponentProps<{vstGrp: string; type: string; ccBiggerZero: string;}> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & AdditionalDataServiceComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }

  const vstGrpType = getGroupType(props.match.params.type, +props.match.params.ccBiggerZero, t);

  return (
      <>
        <AnalyticsTracking page="offer_vrm/detail" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/offers',
                content: `${t("Route.Offers")}`, link: true
              },
              {key: '2',
                content: `${t("Offer.VSTGrp")}: ${decodeVstGrp(props.match.params.vstGrp)}${vstGrpType && ` (${vstGrpType})`}`,
                active: true
              },

            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            <Grid columns={5} className={"HeadingGrid"} stackable={true}
                  style={{marginBottom: '1em'}}>
                <Grid.Column width={4}>
                    <Dropdown
                        placeholder={t("Offer.SelectDeliverer")}
                        selection
                        search
                        fluid
                        options={
                            props.additionalData.dailyOfferDeliverer ?
                                props.additionalData.dailyOfferDeliverer.map(
                                    (date: any) => {
                                        return {
                                            key: date._id,
                                            text: date._id + ": " + date.AnlName,
                                            value: date._id
                                        }
                                    }
                                ).reverse().concat([{key: "default", text:"", value:null}]).reverse()
                                :
                                []
                        }

                        value={props.filterObject.delivererNo || ""}

                        onChange={(_, data: any)=> {
                            props.handleFilterChange("delivererNo", data.value);
                        }}
                    />
                </Grid.Column>
                <Grid.Column width={4}>
                    <Dropdown
                        placeholder={t("Offer.SelectArticle")}
                        selection
                        search
                        fluid
                        options={
                            props.additionalData.dailyOfferArticles ?

                                props.additionalData.dailyOfferArticles.map(
                                    (date: any) => {
                                        return {
                                            key: date._id,
                                            text: date._id + ": " + date.ArtikelBez,
                                            value: date._id
                                        }
                                    }
                                ).reverse().concat([{key: "default", text:"", value:null}]).reverse()
                                :
                                []
                        }

                        value={props.filterObject.articleNo || ""}

                        onChange={(_, data: any)=> {
                            props.handleFilterChange("articleNo",data.value);
                        }}
                    />
                </Grid.Column>

              <Responsive maxWidth={960} as={Grid.Column} width={3}>
                <SortSelectionButton
                  fluid={true}
                  availableColumns={COLUMNS}
                  currentSortColumn={props.sortColumn}
                  currentDirection={props.sortDirection}
                  onSave={props.handleSortUpdate}/>
              </Responsive>
              <Responsive minWidth={961} as={Grid.Column} width={3}>
                <ColumnSelectionButton
                  fluid
                  availableColumns={COLUMNS}
                  selectedColumns={props.selectedColumns}
                  onSave={props.updateSelectedColumns}/>
              </Responsive>

              <Grid.Column width={4}>
                <Grid.Column>
                  <Segment style={{paddingTop:"9.5px", paddingBottom: "9.5px"}}><b>Summe:</b> {props && props.data && props.data.length > 0 ? props.data[0].sum : 0}</Segment>
                </Grid.Column>
              </Grid.Column>

              <ViewLoadingSpinner active={props.loading} />

            </Grid>
          </div>
        </div>


        <div className={"ui container responsivewrapper"}>
          <Responsive minWidth={961}>
          <DataTable
              columns={COLUMNS}
              data={props.data}
              page={props.page}
              totalPages={props.totalPages}
              sortDirection={props.sortDirection}
              sortColumn={props.sortColumn}
              selectedColumns={props.selectedColumns}
              getScrollParent={getScrollParent}
              loadMore={props.loadMore}
              handleSortChange={props.handleSortChange}
              loading={props.loading}
          />
          </Responsive>
          <Responsive maxWidth={960}>
            <DataList data={props.data}
                      page={props.page}
                      totalPages={props.totalPages}
                      getScrollParent={getScrollParent}
                      loadMore={props.loadMore}
                      columns={COLUMNS}
                      renderItem={renderMobileListItems}
            />
          </Responsive>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const renderMobileListItems = (row: any, t: TranslationFunction) => {
  return <>
    <div>
      <div><strong>{row.data.ArtikelBez}</strong></div>
      <div>{t('Offer.ArtikelNr')} {row.data.ArtikelNr} ⸱ {t('Offer.Qualitaet')} {row.data.Qualitaet}</div>
      <div>{t('Offer.Laenge')} {row.data.SCodeWert01Text} ⸱ {t('Offer.Gewicht')} {row.data.SCodeWert02Text || '-'}</div>
    </div>
    <div style={{textAlign: 'right', flexGrow: 1}}>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>{t('Offer.Gesamt')} {row.data.EinheitenGesamt}&nbsp;</div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>{t('Offer.Einheiten')} {row.data.Einheiten}&nbsp;</div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>{t('Offer.EinheitsMenge')} {row.data.EinheitsMenge}&nbsp;</div>
      </div>
    </div>
  </>;
};

const WrappedComponent = withRouter(withAdditionalDataServices(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(DataPage))))))));

export default (props: RouteComponentProps<{vstGrp: string; type: string; ccBiggerZero: string;}>) => {
  const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
      return RestClient.get(`todays-offer/${encodeURIComponent(decodeVstGrp(props.match.params.vstGrp))}/${encodeURIComponent(props.match.params.type)}/${props.match.params.ccBiggerZero}`, {
        date: '',
        filter: '',
        sortBy: sortColumn,
        sortDirection: sortOrder,
        page: page,
        count: 50,
        articleNo: filter.articleNo,
        delivererNo: filter.delivererNo,
      });
    }
  };
  return (
      <WrappedComponent
          viewName="daily_offer_details"
          defaultSortDirection="ASC"

          dataService={dataService}

          dataToLoad={{
              dailyOfferArticles: {
                  "uri": `/todays-offer-articles/${encodeURIComponent(decodeVstGrp(props.match.params.vstGrp))}/${encodeURIComponent(props.match.params.type)}/${props.match.params.ccBiggerZero}`
              },
              dailyOfferDeliverer: {
                  "uri": `/todays-offer-deliverers/${encodeURIComponent(decodeVstGrp(props.match.params.vstGrp))}/${encodeURIComponent(props.match.params.type)}/${props.match.params.ccBiggerZero}`
              }
          }}

          defaultSortColumn="data.ArtikelBez"
          defaultColumns={DEFAULT_COLUMNS}
          defaultFilter={{
          }}
          printColumns={COLUMNS}
          printPath={[
            `${t("Route.Offers")}`,
            `${t("Offer.VSTGrp")}: ${decodeVstGrp(props.match.params.vstGrp)}`
          ]}
      />
  );

}
